/**
 * Returns a promise that resolves after `ms` milliseconds.
 *
 * Used by the bulk password reset loop in `Users.tsx` (#2253) to throttle
 * sequential `AdminResetUserPassword` calls — the default Cognito limit is
 * roughly 5 RPS per account, so the loop sleeps 100ms between calls.
 *
 * Separating this into its own module (rather than inlining
 * `new Promise(r => setTimeout(r, ms))` at the call site) gives tests a
 * stable mock target — `vi.mock('../utils/sleep', ...)` substitutes a
 * spy without touching `setTimeout` globally.
 */
export const sleep = (ms: number): Promise<void> =>
    new Promise<void>((resolve) => {
        setTimeout(resolve, ms);
    });
